import React, { useMemo } from 'react';
import { Image, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import { Colors, Radius, Typography } from '../../theme';
import type { ChatMessage } from '../../types';

interface Props {
  gif: NonNullable<ChatMessage['gif']>;
  onPress?: () => void;
}

const GifMessageBubble: React.FC<Props> = ({ gif, onPress }) => {
  const aspectRatio = useMemo(() => Math.max(0.7, Math.min(1.6, gif.width / Math.max(1, gif.height))), [gif.height, gif.width]);

  return (
    <TouchableOpacity activeOpacity={0.9} onPress={onPress} style={[styles.wrap, { aspectRatio }]}>
      <Image source={{ uri: gif.previewUrl || gif.url }} style={StyleSheet.absoluteFill} resizeMode="cover" />
      <LinearGradient
        pointerEvents="none"
        colors={['transparent', 'rgba(0,0,0,0.24)']}
        style={StyleSheet.absoluteFill}
      />
      <View style={styles.badge}>
        <Text style={styles.badgeText}>GIF</Text>
      </View>
    </TouchableOpacity>
  );
};

export default GifMessageBubble;

const styles = StyleSheet.create({
  wrap: {
    width: 220,
    maxHeight: 270,
    minHeight: 132,
    borderRadius: Radius.lg,
    overflow: 'hidden',
    backgroundColor: Colors.bgCardAlt,
  },
  badge: {
    position: 'absolute',
    left: 8,
    bottom: 8,
    borderRadius: Radius.pill,
    backgroundColor: 'rgba(0,0,0,0.42)',
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.18)',
    paddingHorizontal: 7,
    paddingVertical: 3,
  },
  badgeText: {
    color: '#fff',
    fontSize: 9,
    fontWeight: Typography.extrabold,
    letterSpacing: 0.8,
  },
});
